<section class="Login u-spacing-2xl-pt">
    <div class="Login-intro u-spacing-xl-mb">
        <h2 class="Login-title u-text-title-lg u-color-text-primary u-spacing-sm-mb">Inspector sign-in</h2>
        <p class="Login-description u-text-body-md u-color-text-secondary">
            Enter the CTEP inspector password to access the event log.
        </p>
    </div>

    <form
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        class="Login-form"
        novalidate
        data-testid="login-form"
        autocomplete="off"
    >
        <ce-form-field class="Login-field">
            <label ce-input-label for="password" class="u-text-label-sm">Password</label>
            <input
                ce-input
                id="password"
                type="password"
                autocomplete="off"
                spellcheck="false"
                [formControl]="passwordControl"
                data-testid="password-input"
            />
            @if (passwordControl.touched && passwordControl.errors?.['required']) {
                <span ce-input-error>cannot be empty</span>
            }
            @if (errorMessage()) {
                <span ce-input-error data-testid="login-error">{{ errorMessage() }}</span>
            }
        </ce-form-field>

        <button
            ce-button-large
            ce-button-type-primary
            class="Login-submit u-spacing-md-mt"
            [disabled]="submitDisabled()"
            data-testid="login-submit"
        >
            @if (loading()) {
                <span class="flex flex-center">
                    <ce-spinning-loader />
                </span>
            } @else {
                Sign in
            }
        </button>
    </form>
</section>
